module.exports = __webpack_public_path__ + "static/media/subtract.6c4365df.svg";